import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { purchases } from '../data/purchases';
const FIRST_DELAY = 8000;
const INTERVAL = 20000;
const VISIBLE_TIME = 6500;
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimeout: number;
    const show = () => {
      setIsVisible(true);
      hideTimeout = window.setTimeout(() => {
        setIsVisible(false);
        setIndex(prev => (prev + 1) % purchases.length);
      }, VISIBLE_TIME);
    };
    const firstTimeout = window.setTimeout(show, FIRST_DELAY);
    const interval = window.setInterval(show, INTERVAL);
    return () => {
      window.clearTimeout(firstTimeout);
      window.clearTimeout(hideTimeout);
      window.clearInterval(interval);
    };
  }, [dismissed]);
  const purchase = purchases[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 right-4 z-50 sm:right-auto sm:max-w-sm" aria-live="polite" data-id="element-243" data-mp="163wh542rsm84">
      <AnimatePresence data-id="element-244" data-mp="1fvizdkdizlkd">
        {isVisible && !dismissed ? <motion.div key={`${purchase.name}-${index}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.26,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex items-start gap-3 rounded-xl border border-sage-line bg-paper p-3.5 shadow-lift sm:p-4" data-id="element-245" data-mp="1fv98zvokjce5">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-sage-tint" data-id="element-246" data-mp="s56fdb509ydf">
              <ShoppingBagIcon className="h-4 w-4 text-sage-deep" aria-hidden="true" data-id="element-247" data-mp="28iwlsojlkyq8" />
            </span>
            <div className="flex-1" data-id="element-248" data-mp="23kv86j4xxrm5">
              <p className="text-[13px] leading-snug text-ink sm:text-[13.5px]" data-id="element-249" data-mp="2aol3ga6w861o">
                <strong className="font-sans font-semibold" data-id="element-250" data-mp="2aqxlencnigeq">{purchase.name}</strong> de{' '}
                {purchase.city} compró <span className="font-sans font-medium" data-id="element-251" data-mp="2kmr5crsp9c6j">Armonía Interior</span>
              </p>
              <p className="mt-1 text-[11px] text-ink-mute" data-id="element-252" data-mp="2pltzvib20009">
                Hace {purchase.minutesAgo} minutos · compra verificada
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso de compra" className="-mr-1 -mt-1 flex h-7 w-7 items-center justify-center rounded-full text-ink-mute transition-colors duration-150 ease-out hover:bg-sand hover:text-ink" data-id="element-253" data-mp="1rzwpy9aqp2zx">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-254" data-mp="26o19tglj3kka" />
            </button>
          </motion.div> : null}
      </AnimatePresence>
    </div>;
}